import { render, staticRenderFns } from "./Servers.vue?vue&type=template&id=61d3c846&scoped=true"
import script from "./Servers.vue?vue&type=script&lang=js"
export * from "./Servers.vue?vue&type=script&lang=js"
import style0 from "../css/utilities/scoped/servers.css?vue&type=style&index=0&id=61d3c846&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3c846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d3c846')) {
      api.createRecord('61d3c846', component.options)
    } else {
      api.reload('61d3c846', component.options)
    }
    module.hot.accept("./Servers.vue?vue&type=template&id=61d3c846&scoped=true", function () {
      api.rerender('61d3c846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Servers.vue"
export default component.exports